module.exports = __webpack_public_path__ + "img/6.4f4bb803.png";